import { Environment } from '../../../../environment';
import { Apiesolicitacao } from '../axiosestoque';
import axios, { AxiosError } from "axios";

export interface IGetSolicitacao {
  idsolicitacao: string;
  idlocalizacao: string;
  solicitante: string;
  dataabertura: Date;
  dataenvio: Date;
  impresso?: boolean;
  datavisualizado?: Date;
  obs?: string;
  status: number;
  item: IItenssolicitacao[];
}
export interface ISolicitacaoUpdate {
  impresso?: boolean;
  datavisualizado?: Date;
  status?: number;
  item: IItenssolicitacao[];
}
export interface IItenssolicitacao {
  iditem: string;
  idsolicitacao: string;
  qtd: number;
  qtdenviado: number;
  descricao: string;
  datalan: Date;
  un: string;
  referencia: string;
  urgente: boolean;
  status: number;
}
export interface IUpdateImg {
  urlimge: string;
}
type TComTotalCount = {
  data: ISolicitacaoUpdate[];
  totalCount: number;
}
const handleApiError = (error: unknown): Error => {
  if (axios.isAxiosError(error)) {
    const axiosError = error as AxiosError;
    if (axiosError.response) {
      const errorMessage =
        (axiosError.response.data as any)?.message ||
        axiosError.message ||
        "Erro desconhecido";
      return new Error(errorMessage);
    } else if (axiosError.request) {
      return new Error("Nenhuma resposta do servidor");
    } else {
      return new Error(axiosError.message);
    }
  }
  return new Error((error as Error).message || "Erro inesperado");
};
const getAll = async (id = '', page = 1, tipo = ''): Promise<TComTotalCount | Error> => {
  try {
    const urlRelativa = `/solicitacao?page=${page}&limit=${Environment.LIMITE_DE_LINHAS}&id=${id}&tipo=${tipo}`;

    const { data, headers } = await Apiesolicitacao.get(urlRelativa);

    if (data) {
      return {
        data,
        totalCount: Number(headers['x-total-count'] || Environment.LIMITE_DE_LINHAS),
      };
    }
    return new Error('Erro ao listar os registros.');
  } catch (error) {
    return new Error((error as { message: string }).message || 'Erro ao listar os registros.');
  }
};
const getById = async (id: string): Promise<IGetSolicitacao | Error> => {
  try {
    const { data} = await Apiesolicitacao.get(`/solicitacao/detalhes/${id}`);
    if (data) {
      return data;
    }
    return new Error('Erro ao consultar o registro.');
  } catch (error) {
    console.error(error);
    return new Error((error as { message: string }).message || 'Erro ao consultar o registro.');
  }
};
const updateById = async (
  id: string,
  dados: ISolicitacaoUpdate,
  dadositens: IItenssolicitacao[]
): Promise<void | Error> => {
  try {
    const dadosExtraidos = dadositens.map(({
      iditem,
      qtd,
      qtdenviado,
      status
    }) => ({
      iditem,
      qtd,
      qtdenviado,
      status
    }));
    const { item, ...dadosisolicitacao } = dados;
    const dadosSolicitacao = { idsolicitacao: id, ...dadosisolicitacao };

    await Apiesolicitacao.put(`/solicitacao/${id}`, [dadosSolicitacao, dadosExtraidos]);
  } catch (error) {
    return handleApiError('dentro do console ' + error);
  }
}
const updateItemById = async (
  iditem: string,
  qtd: number,
  qtdenviado: number,
  status: number
): Promise<void | Error> => {
  try {
    const body = {qtd, qtdenviado, status };
    await Apiesolicitacao.put(`/solicitacaoitem/${iditem}`, body);
  } catch (error) {
    return handleApiError('Erro ao atualizar item: ' + error);
  }
};

export const SolicitacaoService = {
  getAll,
  getById,
  updateById,
  updateItemById,
 
};